import 'i18next-browser-languagedetector';
import { applyMiddleware, combineReducers, compose, createStore } from 'redux';
import thunk from 'redux-thunk';

import { env } from '../constants';
import { Authentication } from '../models/authentication';
import { User } from '../models/user';
import authReducers from './authentication/reducers';
import siteConfigReducers from './siteConfig/reducers';
import userReducers from './user/reducers';
import { AuthActionTypes } from './authentication/types';
import { CustomerOverviewState } from '../models/customerOverview';
import customerOverviewReducers from './customerOverview/reducers';
import CustomerDetailReducers from './customerDetails/reducers';
import { CustomerDetailsState } from '../models/CustomerDetails';
import { SiteConfig } from '../models/SiteConfig';
import barcodeReducers from './barcode/reducers';
import { Barcode } from '../models/barcode';
import healthReducers from './health/reducers';
import kitReducers from './kit/reducers';
import { Kit } from '../models/kit';
import { CreateProfileResult, ProfileTransfer } from '../models/profile';
import profileTransferReducer from './profileTransfer/reducers';

export interface AppState {
  siteConfig: SiteConfig;
  authentication: Authentication;
  user: User;
  barcode: Barcode;
  profile: CreateProfileResult;
  kit: Kit;
  customerOverview: CustomerOverviewState;
  customerDetails: CustomerDetailsState;
  profileTransfer: ProfileTransfer;
}

const appReducer = combineReducers({
  siteConfig: siteConfigReducers,
  authentication: authReducers,
  user: userReducers,
  barcode: barcodeReducers,
  profile: healthReducers,
  kit: kitReducers,
  customerOverview: customerOverviewReducers,
  customerDetails: CustomerDetailReducers,
  profileTransfer: profileTransferReducer,
});

const rootReducer = (state: any, action: any) => {
  if (action.type === AuthActionTypes.ACTION_AUTH_LOGOUT_SUBMIT_SUCCESS) {
    state = undefined;
  }
  return appReducer(state, action);
};

const composeEnhancers = (window as any)['__REDUX_DEVTOOLS_EXTENSION_COMPOSE__'] as typeof compose || compose;
const store = createStore(rootReducer, (env !== 'production') ? composeEnhancers(applyMiddleware(thunk)) : applyMiddleware(thunk));

export default store;